@for (title of titles(); track title; let i = $index) {
  <button
    class="no-style  sidebar-item-class-{{ title }}"
    role="menuitem"
    (click)="openMenu(i)">
    <h3 style="margin-right: 20px">{{ 'side-menu.' + title | translate }}</h3>
  </button>
}
